export const GET_ORIGIN_STATUS = "GET_ORIGIN_STATUS";
export const GET_ORIGIN_STATUS_SUCCESS = "GET_ORIGIN_STATUS_SUCCESS";
export const GET_ORIGIN_STATUS_ERROR = "GET_ORIGIN_STATUS_ERROR";